<thead class="wk-data-table__heading">
    <tr
        class="wk-data-table__heading-row wk-data-table__row"
        cdkDropList
        [cdkDropListData]="dataTableStore.visibleColumns()"
        cdkDropListOrientation="horizontal"
        cdkDragAxis="x"
        (cdkDropListDropped)="dataTableDragging.onColumnDropped($any($event))"
    >
        @if (dataTableContext.selectable()) {
            <th
                class="wk-data-table__heading-cell wk-data-table__cell wk-data-table__cell--selectable"
                [class.wk-data-table__cell--locked]="hasLockedColumns()"
            >
                <checkbox-field-pds3>
                    <input
                        type="checkbox"
                        [checked]="dataTableSelection.areAllSelected()"
                        (keydown)="dataTableSelection.toggleSelectAll()"
                        (change)="dataTableSelection.toggleSelectAll()"
                    />
                </checkbox-field-pds3>
            </th>
        }
        @for (column of dataTableStore.visibleColumns(); track column.fullFieldName()) {
            <th wk-data-table-column [index]="$index" [fieldname]="column.fullFieldName()"></th>
        }

        @if (dataTableContext.actions().length) {
            <th class="wk-data-table__heading-cell wk-data-table__cell--actions"></th>
        }
    </tr>
</thead>
<ng-content />
